export default __webpack_public_path__ + "static/media/planet-venus.db5a3444.svg";